import { type UseQueryResult, useQuery } from '@tanstack/react-query';
import api from '@/axios';
import { GET_PRODUCTION_DECLARATION_MATERIAL_COMMODITY_ORIGIN_DOCUMENTS_KEY } from '@/keys';
import type { ProductionDeclarationCommodityOriginDocument } from '@/types/core/purchase-order/production-declaration-commodity-origin-document';

async function getProductionDeclarationMaterialCommodityOriginDocuments(
  productionDeclarationId: string,
  materialId: string,
  commodityOriginId: string,
  options?: { token?: string },
): Promise<ProductionDeclarationCommodityOriginDocument[]> {
  const response = await api.get<
    ProductionDeclarationCommodityOriginDocument[]
  >(
    `/production-declarations/${productionDeclarationId}/materials/${materialId}/commodity-origins/${commodityOriginId}/documents`,
    {
      params: options?.token ? { token: options.token } : undefined,
    },
  );

  return response.data;
}

export function useGetProductionDeclarationMaterialCommodityOriginDocuments(
  productionDeclarationId: string,
  materialId: string,
  commodityOriginId: string,
  token: string | undefined,
): UseQueryResult<ProductionDeclarationCommodityOriginDocument[], Error> {
  return useQuery({
    queryKey: [
      ...GET_PRODUCTION_DECLARATION_MATERIAL_COMMODITY_ORIGIN_DOCUMENTS_KEY,
      productionDeclarationId,
      materialId,
      commodityOriginId,
      token ?? '',
    ],
    queryFn: async () =>
      await getProductionDeclarationMaterialCommodityOriginDocuments(
        productionDeclarationId,
        materialId,
        commodityOriginId,
        {
          token,
        },
      ),
    enabled: Boolean(
      productionDeclarationId && materialId && commodityOriginId,
    ),
  });
}
